// src/admin/adminApi.js
// Minimal fetch helper for the /api/dashboard/* endpoints, independent of the
// main app's sync.js token wiring since AdminApp manages its own auth state.
//
// Calls "/dashboard/stats", not "/admin/stats" — a route starting with
// "admin" reproducibly 404'd at the Azure Static Web Apps edge even though
// the function was confirmed registered on the backend. See the
// admin-app-status memory doc for the investigation.

const BASE = window.Capacitor?.isNativePlatform?.() ? 'https://habitrak.io/api' : '/api';

export async function fetchAdminStats(firebaseUser, days) {
  const token = await firebaseUser.getIdToken();
  const res = await fetch(`${BASE}/dashboard/stats?days=${days}`, {
    headers: { 'X-Firebase-Auth': token },
  });
  if (res.status === 403) throw new Error('forbidden');
  if (!res.ok) throw new Error(`Request failed (${res.status})`);
  return res.json();
}
